import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { AreaService } from '../services';
import { Area } from '../models';

@Injectable()
export class AreasResolver implements Resolve<any> {

    constructor(private _areaService: AreaService) { }

    resolve(route: ActivatedRouteSnapshot): Observable<Area[]> {
        return this._areaService.getAreas()
    }
}



// WEBPACK FOOTER //
// /app/src/shared/resolvers/areas.resolver.ts